import { render, staticRenderFns } from "./CoverageTabs.vue?vue&type=template&id=0567fde6&scoped=true&"
import script from "./CoverageTabs.vue?vue&type=script&lang=js&"
export * from "./CoverageTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0567fde6",
  null
  
)

export default component.exports